import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';

const FlavorForm = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [appLoader, setAppLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [items, setItems] = useState([]);

  const [apiData, setApiData] = useState({
    title: "",
    title_ar: "",
    flavors: [],
  });


  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);



  const getSingleData = async () => {
    try {
      setAppLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `flavors/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const item = data.data;
        setApiData({
          title: item.title,
          title_ar: item.title_ar,
          flavors: item.flavors,
        });
       
      } else {
        toast.error(data.message);
      }
      setAppLoader(false);
    } catch (error) {
      setAppLoader(false);
      console.log(error);
    }
  };


// Handle input change for the main title/title_ar
  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiData(prev => ({ ...prev, [name]: value }));
  };

  // Handle input change for flavor fields
  const handleFlavorChange = (index, e) => {
    const { name, value } = e.target;
    setApiData(prev => {
      const updatedFlavors = [...prev.flavors];
      updatedFlavors[index] = { ...updatedFlavors[index], [name]: value };
      return { ...prev, flavors: updatedFlavors };
    });
  };

  // Add a new empty flavor
  const addFlavor = () => {
    setApiData(prev => ({
      ...prev,
      flavors: [...prev.flavors, { title: "", title_ar: "" }]
    }));
  };

  // Remove a flavor by index
  const removeFlavor = (index) => {
    setApiData(prev => ({
      ...prev,
      flavors: prev.flavors.filter((_, i) => i !== index)
    }));
  };



const submitForm = async (e) => {
  e.preventDefault();
  setIsLoader(true);
  
  try {
    const formData = new FormData();

    // Append main fields (title, title_ar)
    formData.append("title", apiData.title);
    formData.append("title_ar", apiData.title_ar);

    // Append flavors array
    apiData.flavors.forEach((flavor, index) => {
      formData.append(`flavors[${index}][title]`, flavor.title);
      formData.append(`flavors[${index}][title_ar]`, flavor.title_ar);
    });

    const response = await ApiService.request({
      method: 'POST',
      url: `flavors/createOrUpdate/${id || ''}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const data = response.data;
    if (data.status) {
      toast.success(data.message);
      navigate("/flavors");
    } else {
      toast.error(data.message);
    }
  } catch (error) {
    console.error("Submit failed:", error);
    toast.error("An error occurred while submitting the form");
  } finally {
    setIsLoader(false);
  }
};



  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? "Edit" : "Add New"} Flavor
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="/dashboard" className="text-muted text-hover-primary">
                  Dashboard
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <a href="/flavors" className="text-muted text-hover-primary">
                  Flavors
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form
                id="kt_modal_new_target_form"
                encType="multipart/form-data"
                method="POST"
                className="form fv-plugins-bootstrap5 fv-plugins-framework"
                onSubmit={submitForm}
              >
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Item Title"
                      required
                      value={apiData.title}
                      name="title"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title Arabic</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Item Title Ar"
                      required
                      value={apiData.title_ar}
                      name="title_ar"
                      onChange={handleChange}
                    />
                  </div>
               
                </div>

                <h5 className="mt-15">
                  Flavors: 
                  <button className="btn btn-base btn-sm mx-3" type="button" onClick={addFlavor}>
                    Add New
                  </button>
                </h5>

                <div className="table-responsive">
                  <table className="table fs-6 gx-5">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Title Ar</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {apiData.flavors.map((flavor, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-solid"
                              placeholder="Enter Flavor Title"
                              required
                              value={flavor.title}
                              name="title"
                              onChange={(e) => handleFlavorChange(index, e)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-solid"
                              placeholder="Enter Flavor Title Arabic"
                              required
                              value={flavor.title_ar}
                              name="title_ar"
                              onChange={(e) => handleFlavorChange(index, e)}
                            />
                          </td>
                          <td>
                            <button 
                              className="btn btn-danger btn-sm"  type="button"
                              onClick={() => removeFlavor(index)}
                            >
                              <i className="bi bi-trash-fill"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

           
           

                {/* Form Actions */}
                <div className="row g-9 my-3">
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      onClick={() => navigate("/flavors")}
                    >
                      Back
                    </button>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      {isLoader ? (
                        <Loader size="20" text="Submitting" />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlavorForm;
